// extracted by mini-css-extract-plugin
export var closeButton = "_jy-1";
export var closeX = "_jy-3";
export var container = "_jy-0";
export var image = "_jy-2";